import CudaPaper from 'common/components/CudaPaper';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import SearchBar from 'common/components/SearchBar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        padding: '10px 1px',
        alignSelf: 'flex-start'
    },
    title: {
        padding: '16px',
    },
    table:{
        width: '100%',
    }
}

// use this to override the style of searchbox
const searchBarStyle = {
    container: {
        display: 'flex',
        justifyContent: 'Flex-start',
        alignItems: 'center',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        boxShadow: "none",
        height: "40px",
        border:'1px solid #e0e0e0'
    }
};

const StyledSearchBar = withStyles(searchBarStyle)(SearchBar);

const SearchServiceId = ({ classes, fetcher, loading = undefined, search, results, onChange }) => {
    return <Grid className={classes.container}>
        <CudaPaper loading={loading}>
            <Grid container>
                <Grid item xs={12} className={classes.title}>
                    Service IP Search
                </Grid>
                <Grid item xs={12}>
                    {/* // loading={fetcher.loading || isLoading}> */}
                    <StyledSearchBar onChange={search} placeholder='Find service ip by unique log id'
                        autoFocus={false} />
                </Grid>
                {
                    results.length > 0 &&
                    <Grid item xs={12}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Log ID</TableCell>
                                    <TableCell>Service IP</TableCell>
                                    <TableCell>destinationServiceName</TableCell>
                                    <TableCell>Timestamp</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    results.map(res => 
                                        <TableRow>
                                            <TableCell>{res['logData_UniqueID']}</TableCell>
                                            <TableCell>{res['logData_ServiceIP']}</TableCell>
                                            <TableCell>{res['logData_destinationServiceName']}</TableCell>
                                            <TableCell>{res['timestamp']}</TableCell>
                                        </TableRow>)
                                }
                            </TableBody>
                        </Table>
                    </Grid>
                }
            </Grid>
        </CudaPaper>
    </Grid>

}

export default withStyles(styles)(SearchServiceId);